<!--  -->
<template>
  <div>
    <loading :loading="loading"></loading>
    <div class="home-container">
      <!-- 针对pc端 -->
      <div
        class="pcshow_wrap"
        v-if="screenWidth > 768 || assemblyDTOs.length > 0"
      >
        <!-- <nav-web></nav-web> -->
        <div v-for="(component, index) in assemblyDTOs" :key="index">
          <!-- 海报组件 -->
          <template
            v-if="
              (component.type == 'POSTERLIST' &&
                $store.state.userLogin &&
                component.nextDetailsDTOs[0].showType == 'member') ||
              (component.type == 'POSTERLIST' &&
                component.nextDetailsDTOs[0].showType == 'all')
            "
          >
            <hai-bao
              @toggleMeau="toggleMeau"
              :componentIndex="index"
              :returnData="component"
              v-on:loadingFun="loadingFun"
            ></hai-bao>
          </template>
        </div>
      </div>
      <div
        class="mobshow_wrap"
        v-if="screenWidth <= 768 || assemblyDTOs.length > 0"
      >
        <div v-for="(component, index) in assemblyDTOsMB" :key="index">
          <!-- 海报组件 -->
          <div v-show="index>0 && showMap[index-1] && isShowDelay"> 
            <div v-is-intersecting.instant="viewHandler" :index="index" class="showIndex"></div>
          </div>
          <div v-if="index==0 || index==1 || showMap[index]">
            <template
              v-if="
                (component.type == 'CAROUSEPOSTER' &&
                  $store.state.userLogin &&
                  component.nextDetailsDTOs[0].showType == 'member') ||
                (component.type == 'CAROUSEPOSTER' &&
                  component.nextDetailsDTOs[0].showType == 'all')
              "
            >
              <carousel-poster
                :componentIndex="index"
                :returnData="component"
              ></carousel-poster>
            </template>
            <template
              v-if="
                (component.type == 'BASELIST' &&
                  $store.state.userLogin &&
                  component.nextDetailsDTOs[0].showType == 'member') ||
                (component.type == 'BASELIST' &&
                  component.nextDetailsDTOs[0].showType == 'all')
              "
            >
              <good-display
                :componentIndex="index"
                :returnData="component"
              ></good-display>
            </template>
            <template v-if="component.type == 'LOGLIST'">
              <blog :componentIndex="index" :returnData="component"></blog>
            </template>
          </div>
          <!-- <template v-if="component.component_id==0">
          <hai-bao :componentIndex="index" :returndata="component.detail"></hai-bao>
          </template>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import HaiBao from "../common/customize/HaiBao";
import CarouselPoster from "../common/customize/CarouselPoster";
import GoodDisplay from "../common/customize/GoodDisplay";
import Blog from "../common/customize/Blog";
import Loading from "../common/Loading";
export default {
  data() {
    return {
      hasHiddenFalg: false,
      screenWidth: document.body.clientWidth,
      loading: true,
      isPc: false,
      assemblyDTOs: [],
      assemblyDTOsMB: [],
      isShowDelay:false,
      showMap:{
        0:true
      }
    };
  },
  components: { HaiBao, CarouselPoster, GoodDisplay, Blog, Loading },
  watch: {
    "$store.state.screenWidth": {
      immediate: true,
      handler(val) {
        if (!this.timer && val!=null) {
          // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
          this.screenWidth = val;
          this.timer = true;
          let that = this;
      
          if (that.screenWidth < 768 && that.assemblyDTOsMB.length <= 0) {
            that.getHomePageDetailPhone();
          } else if (
            that.screenWidth >= 786 &&
            that.assemblyDTOs.length <= 0
          ) {
            that.getHomePageDetail();
          }
          setTimeout(()=>{
            that.timer = false;
          },400)
          
        }
      },
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    // this.$utils.CheckOpenIdExist(this);
    let that = this;
    window.screenWidth = document.body.clientWidth;
    that.screenWidth = window.screenWidth;
    if (that.screenWidth < 768) {
      that.getHomePageDetailPhone();
    } else if (
      that.screenWidth >= 786
    ) {
      that.getHomePageDetail();
    }
    setTimeout(()=>{
      this.isShowDelay = true
    },500)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    var that = this;
    if (this.$route.query.showWeChat) {
      this.$store.commit("setValue", ["showWeChatPop", true]);
    }
    // utils.trackData(this,(document.title+','+this.$route.path),'',2);
    this.$gaAction.pageview(document.title, this.$route.path); 
    this.$utils.getEntityAndSetSeoInfo(
        {
          friendlyUrlType: "OTHER",
          link: '/',
        },
        this
      );

  },
  methods: {
    viewHandler(target){
      //页面滚动到第13个商品的时候，执行另外一轮加载另外20个商品的操作 
      let index = parseInt(target.getAttribute("index"));  
      if(!this.showMap[index+""]){ 
        this.$set(this.showMap,index,true)
        index = index+1;
        this.$set(this.showMap,index,true)
      }
    },
    loadingFun() {
      setTimeout(() => {
        this.loading = false;
      }, 1500);
    },
    async getHomePageDetailPhone() { 
      var that = this;
      let url = this.$store.state.API.plp.getPageDetailById;
      let paramsObj = {
        merchantId: this.$store.state.storeId,
        source: "PHONE",
        draft:true,
        type: "home",
        sort: '',
      };
      this.$http
        .get(url + "?" + that.$qs.stringify(paramsObj))
        .then((res) => {
          if (res.status == 200) {
            if (res.data.returnData) {
              this.assemblyDTOsMB = res.data.returnData.assemblyDTOs;
              var count = 0;
              for (var m = 0; m < this.assemblyDTOsMB.length; m++) {
                if (!this.assemblyDTOsMB[m].display) {
                  count = count + 1;
                }
              }
              if (count == this.assemblyDTOsMB.length) {
                this.hasHiddenFalg = true;
              }

              var refound = $(".refound").html();
              if (this.screenWidth < 768) {
                // this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式

                if (refound) {
                  if (this.assemblyDTOsMB.length > 0 && !this.hasHiddenFalg) {
                    document.getElementById("main").style.paddingTop = "0px";
                  } else {
                    document.getElementById("main").style.paddingTop = "124px";
                  }
                } else {
                  if (this.assemblyDTOsMB.length > 0 && !this.hasHiddenFalg) {
                    document.getElementById("main").style.paddingTop = "0px";
                  } else {
                    document.getElementById("main").style.paddingTop = "90px";
                  }
                }
              }
            }

            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async getHomePageDetail() {
      var that = this;
      let url = this.$store.state.API.plp.getPageDetailById;
      let paramsObj = {
        merchantId: this.$store.state.storeId,
        source: "PC",
        type: "home",
        draft:true,
        sort:'',
      };
      this.$http.get(url + "?" + that.$qs.stringify(paramsObj)).then((res) => {
        if (res.status == 200) {
          if (res.data.returnData) {
            this.assemblyDTOs = res.data.returnData.assemblyDTOs;
            // this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式
            var refound = $(".refound").html();
            if (that.screenWidth > 768) {
              if (refound) {
                var clientHeight =
                  document.getElementById("header-container").clientHeight;
                document.getElementById("main").style.paddingTop =
                  clientHeight + "px";
              } else {
                document.getElementById("main").style.paddingTop = "66px";
              }
            }
          }
          // setTimeout(() => {
          //   this.loading = false;
          // }, 1000);
        }
      });
    },
    toggleMeau(e) {

      let componentIndex = e.componentIndex;
      let sideIndex = e.sideIndex;
      // 需要改变的key需要提前在对象里设好，要不然需要set
      this.ComponentData[componentIndex].detail.Info[sideIndex].meau_open =
        !this.ComponentData[componentIndex].detail.Info[sideIndex].meau_open;
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
  },
};
</script>

<style scoped lang="less">
/* @import url(); 引入css类 */
.home-container {
  // padding: 2.5rem 5rem;
  text-transform: none;
  .pcshow_wrap {
    display: block;
    margin-top: -2.5rem;
    padding-bottom: 2.5rem;
  }
  .mobshow_wrap {
    display: none;
  }
}

@media screen and (max-width: 1024px) {
}
@media screen and (max-width: 768px) {
  .home-container {
    .pcshow_wrap {
      display: none;
    }
    .mobshow_wrap {
      display: block;
    }
  }
}

/deep/.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  margin: 0 3px;
}
/deep/.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 3px;
}
/deep/.good_price {
  display: none;
}
/deep/main .menu_box .child_menu_content {
  padding-bottom: 10rem;
  background: red;
}
/deep/.good-container {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/home.vue